/**
 * International phone-number validation.
 * Rule: value must start with "+" followed by a country code (1-3 digits) and
 * a sufficient number of additional digits (total 8-15 digits per E.164).
 * Spaces, dashes, parentheses, and dots are allowed for readability — we strip
 * them before validating.
 */
export const INTERNATIONAL_PHONE_HINT = "Include the country code, e.g. +39 393 907 8663";

/** Returns true when the value looks like a valid international phone number. */
export function isValidInternationalPhone(raw) {
  if (!raw) return false;
  const trimmed = String(raw).trim();
  if (!trimmed.startsWith("+")) return false;
  const digits = trimmed.slice(1).replace(/[\s\-().]/g, "");
  // E.164 allows 8-15 digits; require at least 8 to reduce false positives
  return /^[1-9]\d{7,14}$/.test(digits);
}

/** Returns a short error string or "" when valid. */
export function phoneValidationError(raw) {
  if (!raw) return "Phone number is required";
  if (!String(raw).trim().startsWith("+"))
    return `Missing country code. ${INTERNATIONAL_PHONE_HINT}`;
  if (!isValidInternationalPhone(raw))
    return `Invalid phone number. ${INTERNATIONAL_PHONE_HINT}`;
  return "";
}
